import { authModuleIds } from 'root/src/client/web/auth/descriptions/modules/authModuleIds';
export const transformToCreatorModalModule = {
    [authModuleIds.TRANSFORM_TO_CREATOR]: {
        moduleType: 'modal',
    },
};
